import { AlertTriangle } from "lucide-react";
import { MESSAGES } from "../../utils/contactFilter";

/**
 * Amber banner shown above chat composers when the current draft
 * matches a contact-leak rule. UX-only — server enforces the rule.
 */
export default function ContactLeakBanner({ rule }) {
  if (!rule) return null;
  const text = MESSAGES[rule] || MESSAGES.whatsapp;
  return (
    <div
      data-testid="contact-leak-banner"
      data-rule={rule}
      className="flex items-start gap-2 px-3 py-2 mb-2 rounded-[12px] border"
      style={{
        background: "#FFF7ED",
        borderColor: "#F59E0B",
        color: "#7C2D12",
      }}
    >
      <AlertTriangle size={16} className="shrink-0 mt-[2px]" />
      <div className="text-[12px] leading-snug">{text}</div>
    </div>
  );
}
